// Generic cache class
export default class CacheG<T> {
    protected _dict: { [key: string]: T } = {};

    public find(key: string): T | null {
        return this._dict[key] || null;
    }

    public set(key: string, value: T): void {
        this._dict[key] = value;
    }

    public contains(key: string): boolean {
        return this._dict.hasOwnProperty(key);
    }

    public clear(): void {
        this._dict = {};
    }

    public delete(key: string): void {
        delete this._dict[key];
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/cache.ts